/*
 * Copyright (C) 2021 Bosch.IO GmbH. All rights reserved.
 */

import * as React from 'react';
import classNames from 'classnames';

import { Icon } from '../icon/icon';

export interface PinProps extends React.HTMLAttributes<HTMLDivElement> {
    isDisabled?: boolean;
    isCluster?: boolean;
    clusterLabel?: number | string | React.ReactNode;
    children: never;
}

/**
 * @name        a-pin
 * @type        atom
 * @author    tss1imb
 * @copyright   Robert Bosch GmbH
 *
 * @param       {boolean}   isDisabled    Wether or not the pin is disabled
 * @param       {boolean}   isCluster     Wether or not the pin is a cluster
 * @param       {number}    clusterLabel  Label to display on a cluster pin
 * @description
 * representation of pins
 */

export const Pin = React.forwardRef<HTMLDivElement, PinProps>(
    ({ isDisabled, isCluster, clusterLabel, ...rest }, ref) => {
        const pinClass = classNames('a-pin', {
            'a-pin--cluster': isCluster,
            '-disabled': isDisabled,
        });

        return (
            <div className={pinClass} {...rest} ref={ref}>
                {isCluster ? clusterLabel : <Icon iconName="pin" isUiIcon />}
            </div>
        );
    },
);
